import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSample } from "../../utils/useSample";
import {
  useAnalysisTypes,
  useInstallation,
  useSamplingPoints,
  useSamplingReason,
  useTypesAccumulation,
  useTypeSample,
  useUser,
} from "@services/servicesGenericsTables";
import { Loading } from "@app/components";

export default function SampleLayout() {
  const fetched = useRef(false);
  const [loading, setLoading] = useState(true);
  const { fetchAll } = useSample();
  const { fetchAll: fetchAllInstallation } = useInstallation();
  const { fetchAll: fetchAllAnalysis } = useAnalysisTypes();
  const { fetchAll: fetchAllTypeSample } = useTypeSample();
  const { fetchAll: fetchAllAccumulation } = useTypesAccumulation();
  const { fetchAll: fetchAllSamplingPoints } = useSamplingPoints();
  const { fetchAll: fetchAllSamplingReason } = useSamplingReason();
  const { fetchAll: fetchAlluser } = useUser();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      const fetchData = async () => {
        await Promise.all([
          fetchAll(),
          fetchAllInstallation(),
          fetchAllAnalysis(),
          fetchAllTypeSample(),
          fetchAllAccumulation(),
          fetchAllSamplingPoints(),
          fetchAllSamplingReason(),
          fetchAlluser(),
        ]);
        setLoading(false);
      };
      fetchData();
    }
  }, [fetchAll]);

  return loading ? <Loading /> : <Outlet />;
}
